<template>

    <section>
        <p class="info">Seeing page {{ details.page }} of {{ details.totalPages }}</p>
        <div class="controls">
            <p v-for="page in details.totalPages" :key="page" @click="changePage(page)" :class="details.page == page ? 'selected' : ''" >{{ page }}</p>
        </div>
    </section>

</template>

<style scoped lang="scss">
    .controls {
        display: flex;
        padding: 10px 15px;
        p {
            margin: 5px 15px;
            background-color: rgba(0, 0, 0, 0.4);
            box-shadow: 0px 0px 3px #000000ab;
            color: #fff;
            height: 23px;
            width: 25px;
            padding-top: 2px;
            border-radius: 50%;
            cursor: pointer;
            transition: all .3s;
        }
        .selected {
            background: #000;
            box-shadow: 0px 0px 3px #000000ab;
            color: #fff;
        }
    }

    .info {
        font-size: 18px;
    }


</style>

<script>

    export default {
        props: {
            details: Object
        },
        data() {
            return {
            }
        },
        methods: {
            changePage(index) {
                if(index == this.details.page) return;
                this.$emit("pageChanged", index);
            }
        }
    }

</script>